const bitternessConverter = {
  0: 0,
  1: 30,
  2: 40,
  3: 60,
  4: 80,
  5: 120
}

export default bitternessConverter;